var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "big no-padding-confirm",
      attrs: {
        showMask: true,
        closeIcon: true,
        close: _vm.close,
        title: _vm.$t("tradeTxPairManage.incomeList")
      }
    },
    [
      _c("div", { staticClass: "total-income" }, [
        _c("div", { staticClass: "total-income-title" }, [
          _vm._v(_vm._s(_vm.$t("tradeTxPairManage.historyAllIncome")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "income" }, [
          _vm._v(_vm._s(_vm.showTotalIncome))
        ])
      ]),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "income-list-table",
          attrs: { headList: _vm.headList, contentList: _vm.contentList }
        },
        [
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.currentPage + 1,
              toPage: _vm.fetchIncomeList,
              totalPage: _vm.totalPage
            },
            slot: "tableBottom"
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }